import { buildCanonicalProfileUpdate } from "../../../helpers/canonicalProfileUpdate";
import { mergeEditableProfile } from "./editableProfile";

export const buildSponsorLocalProfile = (profileInfo, updatedFields = {}) => {
  const merged = mergeEditableProfile(profileInfo, updatedFields);
  const sponsorProfile = merged?.profile?.sponsorProfile;

  if (sponsorProfile && !Array.isArray(sponsorProfile.countriesOrCities)) {
    return {
      ...merged,
      profile: {
        ...merged.profile,
        sponsorProfile: {
          ...sponsorProfile,
          countriesOrCities: [],
        },
      },
    };
  }

  return merged;
};

export const buildSponsorProfileUpdate = (profileInfo, updatedFields = {}) => {
  const payload = buildCanonicalProfileUpdate(updatedFields ?? {});
  const sponsorProfile = payload.profile?.sponsorProfile;
  const locationFields = [
    "organizationalScope",
    "primaryCity",
    "province",
    "regions",
    "countriesOrCities",
  ];

  if (
    !sponsorProfile ||
    !locationFields.some((field) => field in sponsorProfile)
  ) {
    return payload;
  }

  const organizationalScope =
    sponsorProfile.organizationalScope ??
    profileInfo?.profile?.sponsorProfile?.organizationalScope;
  const clearedLocationFields = {
    local: { countriesOrCities: [], regions: [] },
    regional: { countriesOrCities: [], primaryCity: "", province: "" },
    international: { primaryCity: "", province: "", regions: [] },
    national: {
      countriesOrCities: [],
      primaryCity: "",
      province: "",
      regions: [],
    },
  };

  return {
    ...payload,
    profile: {
      ...payload.profile,
      sponsorProfile: {
        ...sponsorProfile,
        ...clearedLocationFields[organizationalScope],
      },
    },
  };
};
